import Vue from 'vue'
import { routes } from './router'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import { mJump } from '@/utils/isMobile.js'

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // 解决路由跳转后 会滚动到底部
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  mJump('http://ffgj.dhirp.com')
  next()
})
export default router
